export default {
  '新增计划':'新增计划',
  '计划名称':'计划名称',
  '请输入计划名称':'请输入计划名称',
  '内容及范围':'内容及范围',
  '测试类型':'测试类型',
  '体测模拟':'体测模拟',
  '体考模拟':'体考模拟',
  '测试标准':'测试标准',
  '请选择测试标准':'请选择测试标准',
  '测试项目':'测试项目',
  '项目与分值':'项目与分值',
  '项目满分':'项目满分',
  '总满分':'总满分',
  '必考':'必考',
  '一类选考项目':'一类选考项目',
  '二类选考项目':'二类选考项目',
  '不限':'不限',
  '仅限男':'仅限男',
  '仅限女':'仅限女',
  '请输入分值':'请输入分值',
  '计算方式':'计算方式',
  '请输入总满分':'请输入总满分',
  '请填写计算方式':'请填写计算方式',
  '精度':'精度',
  '取值方式':'取值方式',
  '整数':'整数',
  '小数点后一位':'小数点后一位',
  '小数点后两位':'小数点后两位',
  '小数点后三位':'小数点后三位',
  '四舍五入':'四舍五入',
  '向上取整':'向上取整',
  '向下取整':'向下取整',
  '最终总分数':'最终总分数',
  '是否报名':'是否报名',
  '是':'是',
  '否':'否',
  '测试报告':'测试报告',
  '线上支付':'线上支付',
  '请输入':'请输入',
  '元':'元',
  '线下支付':'线下支付',
  '免费':'免费',
  '测试范围':'测试范围',
  '请选择测试范围':'请选择测试范围',
  '请填写计划名称':'请填写计划名称',
  '请选择测试时间':'请选择测试时间',
  '请选择测试类型':'请选择测试类型',
  '请选择测试项目':'请选择测试项目',
  '请填写测试项目分值':'请填写测试项目分值',
  '请输入项目分值':'请输入项目分值',
  '请输入项目计算方式':'请输入项目计算方式',
  '一类选考项目需填写相同分值':'一类选考项目需填写相同分值',
  '二类选考项目需填写相同分值':'二类选考项目需填写相同分值',
  '请填写最终总分数计算方式':'请填写最终总分数计算方式',
  '请输入有效的计算方式':'请输入有效的计算方式',
  '请选择是否报名':'请选择是否报名',
  '请选择测试报告支付方式':'请选择测试报告支付方式',
  '金额至少为':'金额至少为0.01',
  '请选择测试班级':'请选择测试班级',
  '是否取消':'是否取消',
  '取消后，页面数据不做保存':'取消后，页面数据不做保存',
  '查看计划':'查看计划',
  '详情':'详情',
  '报名':'报名',
  '已报名':'已报名',
  '未报名':'未报名',
  '明细':'明细',
  '报名模板':'报名模板',
  '批量成绩导入失败列表':'批量成绩导入失败列表',
  '姓名与学籍号与失败原因':'姓名,学籍号,失败原因',
  '批量成绩导入失败列表':'批量成绩导入失败列表',
  '组织测试列表':'组织测试列表',
  '确认要提前结束该计划':'确认要提前结束该计划：',
  '计划结束后不再支持学生测试':'计划结束后不再支持学生测试',
  '确认要删除该计划':'确认要删除该计划：',
  '删除后将无法查看本计划数据':'删除后将无法查看本计划数据',
  '参与机构':'参与机构',
  '测试名称':'测试名称',
  '测试周期':'测试周期',
  '成绩导入':'成绩导入',
  '成绩导出':'成绩导出',
  '测试记录':'测试记录',
  "删除计划成功":'删除计划成功',
  "提前结束测试成功":'提前结束测试成功',
  "测试成绩导出":'测试成绩导出',
  "全校":'全校',
  "部分":'部分',
  "（标准已删除）":'（标准已删除）',
  "（标准已停用）":'（标准已停用）',
  "测试计划已结束":'测试计划已结束，不可编辑哦',
  "数据来源":'数据来源',
  "是否自助测试":'是否自助测试',
  "是":'是',
  "否":'否',
  "测试方式":'测试方式',
  "校内组织":'校内组织',
  "自助测试":'自助测试',
  "运动详情":'运动详情',
  "运动视频片段":'运动视频片段',
  "运动过程图片":'运动过程图片',
  "录入":'录入',
  '计划明细导入完成':'计划明细导入完成',
  '计划明细模板':'计划明细模板',
  '学生是否预约':'学生是否预约',
  '可预约日期':'可预约日期',
  '预约配置':'预约配置',
  '去设置':'去设置',
  '去修改':'去修改',
  '跑步类项目可预约时段':'跑步类项目可预约时段',
  '跑步类项目':'跑步类项目',
  '非跑步类项目':'非跑步类项目',
  '预约人数':'预约人数',
  '非跑步类项目可预约时段':'非跑步类项目可预约时段',
  '预约时段':'预约时段',
  '跑步类项目，如50':'跑步类项目，如50/800/1000米跑等',
  '非跑步类项目，如肺活量、仰卧起坐等':'非跑步类项目，如肺活量、仰卧起坐等',
  '预约配置不可为空':'预约配置不可为空',
  '可预约时段不可为空':'可预约时段不可为空',
  '预约人数不可为空':'预约人数不可为空',
  '设置预约信息':'设置预约信息',
  '预约数据导出':'预约数据导出',
  '预约数据':'预约数据​',
  '项目分类':'项目分类​',
  '该时段已有学生预约，删除将清空已有预约数据':'该时段已有学生预约，删除将清空已有预约数据',
  '已有学生预约，切换预约模式清空已有预约数据':'已有学生预约，切换预约模式清空已有预约数据',
  '作废':'作废',
  '确定要作废此记录吗':'确定要作废此记录吗',
  '请修改测试结果':'请修改测试结果',
  '请填写结果':'请填写结果',
  '结果':'结果',
  '导出学生名单':'导出学生名单',
  '考生姓名':'考生姓名',
  '预约详情':'预约详情',
  '预约方式':'预约方式',
  '重复':'重复',
  '自定义':'自定义',
  '请选择重复天数':'请选择重复天数',
  '选择日期':'选择日期',
  '新增日期':'新增日期',
  '请选择测试时间和可预约日期':'请选择测试时间和可预约日期',
  '可预约时段不可重复':'可预约时段不可重复',
  '存在重复可预约时段，请修改':'存在重复可预约时段，请修改',
  '预约学生名单':'预约学生名单',
  '最优成绩导入':'最优成绩导入',
}